import React from 'react';
import { CSSProp } from 'styled-components';

type Props = {
  title: string;
  value: string;
};

function MailRow({ value, title }: Props) {
  const rowStyles: CSSProp = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    width: '100%',
  };

  const titleStyles: CSSProp = {
    height: '30px',
    width: '40%',
    verticalAlign: 'center',
    textAlign: 'right',
    fontSize: '18px',
  };

  const valueStyles: CSSProp = {
    height: '30px',
    width: '60%',
    verticalAlign: 'center',
    textAlign: 'left',
    marginLeft: '20px',
    fontSize: '18px',
  };

  return (
    <div style={rowStyles}>
      <span style={titleStyles}>{title}:</span>
      <span style={valueStyles}>{value}</span>
    </div>
  );
}

export default MailRow;
